define('CustomMatrixOption'
	, [
		'CustomMatrixOption.View'
		, 'underscore'
		, 'Cart.Lines.View'
	]
	, function (
		CustomMatrixOptionView
		, _
		, CartLinesView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout')
					, cartComponent = container.getComponent('Cart')
					, checkoutComponent = container.getComponent('Checkout');

				if (layout) {
					layout.addToViewContextDefinition("Header.MiniCart.View", 'showCheckoutButton', 'boolean', function (context) {
						var isCartLoading = context.isLoading
							, model = context.model
							, showCheckoutButton = true;

						if (!isCartLoading) {
							showCheckoutButton = _.every(model.lines || [], function (line) {
								var showCutLinkOption = line.item.custitem_show_cut_link_on_pdp_page
									, showCutLinkOptionCart = line.item.custitem_show_cut_link_on_cart_page
									, optionCutLink = _.find(line.options || [], { 'cartOptionId': 'custcol_web_cut_link' });
								console.log("showCutLinkOption", showCutLinkOption);
								return showCutLinkOption || showCutLinkOptionCart ? optionCutLink && !_.isEmpty(optionCutLink.value) : true;
							});
						}
						return showCheckoutButton;
					});
				}
				//checkout validation
				if (checkoutComponent) {
					var isValidatingCheckout = false;
					function validateCheckoutPage() {
						try {
							console.log('validateCheckoutPage() called');
							if (isValidatingCheckout) {
								return;
							}
							isValidatingCheckout = true;
							cartComponent.getLines().then(function (lines) {
								console.log('========== CHECKOUT VALIDATION ==========');
								console.log('LINES:', lines);
								var validationFailed = false;
								var errorHtml = '';
								// remove old message
								jQuery('#cut-length-validation-error').remove();
								if (!lines || !lines.length) {
									validationFailed = true;
									errorHtml =
										'<div id="cut-length-validation-error" ' +
										'class="alert alert-danger" ' +
										'style="margin-bottom:25px;">' +

										'<div class="global-views-message global-views-message-error">' +

										'<strong>Cart is Empty</strong><br>' +
										'Please add items to your cart before proceeding to checkout.' +

										'</div></div>';
								}
								else {
									var missingItems = [];
									_.each(lines, function (line, index) {
										var showCutLinkOption =
											line.item.extras &&
											line.item.extras.custitem_show_cut_link_on_pdp_page;
										var showCutLinkOptionCart =
											line.item.extras &&
											line.item.extras.custitem_show_cut_link_on_cart_page;
										var optionCutLink = _.find(
											line.options || [],
											{
												cartOptionId: 'custcol_web_cut_link'
											}
										);
										var cutValue =
											optionCutLink &&
											optionCutLink.value &&
											(
												optionCutLink.value.internalid ||
												optionCutLink.value.label ||
												optionCutLink.value
											);
										if (
											(showCutLinkOption || showCutLinkOptionCart) &&
											!cutValue
										) {
											missingItems.push(
												(index + 1) +
												'. ' +
												line.item.itemid
											);
										}
									});
									if (missingItems.length) {
										validationFailed = true;
										errorHtml =
											'<div id="cut-length-validation-error" ' +
											'class="alert alert-danger" ' +
											'style="margin-bottom:25px;">' +

											'<div class="global-views-message global-views-message-error">' +

											'<strong>Cut Length Required</strong><br><br>' +

											'The following ' + (missingItems.length === 1 ? 'item' : 'items') + ' require' + (missingItems.length === 1 ? 's' : '') + ' a cut length:' +

											'<ul style="margin-top:10px;margin-bottom:0;">';
										_.each(missingItems, function (item) {
											errorHtml +=
												'<li>' +
												item +
												'</li>';
										});
										errorHtml +=
											'</ul>' +
											'<br>Please return to the cart and enter the required cut length for ' +
											(missingItems.length === 1 ? 'this item' : 'these items') +
											' to continue with the checkout process.' +
											'</div></div>';
									}
								}
								if (validationFailed) {
									// Put error above shipping address
									jQuery('#cut-length-validation-error').remove();

									var $container = jQuery('.wizard-content').first();

									console.log('wizard-content found:', $container.length);

									if ($container.length) {
										$container.prepend(errorHtml);
										console.log('Error inserted');
									}
									console.log(
										'After insert:',
										jQuery('#cut-length-validation-error').length
									);
									jQuery('[data-action="submit-step"]')
										.prop('disabled', true)
										.attr('disabled', 'disabled')
										.addClass('disabled');
									jQuery('[data-action="submit-order"]')
										.prop('disabled', true)
										.attr('disabled', 'disabled')
										.addClass('disabled');
									console.log('Checkout blocked');
								}
								else {
									jQuery('[data-action="submit-step"]')
										.prop('disabled', false)
										.removeAttr('disabled')
										.removeClass('disabled');
									jQuery('[data-action="submit-order"]')
										.prop('disabled', false)
										.removeAttr('disabled')
										.removeClass('disabled');
									console.log('Checkout allowed');
								}
								isValidatingCheckout = false;
							}).fail(function () {
								isValidatingCheckout = false;
							});
						} catch (error) {
							console.log("Error in checkout validation", error);
						}
					}
					checkoutComponent.on('afterShowContent', function () {
						validateCheckoutPage();
						// only one retry instead of three
						setTimeout(function () {
							validateCheckoutPage();
						}, 800);
					});
					jQuery(document).on(
						'click',
						'[data-action="submit-step"],[data-action="submit-order"]',
						function (e) {
							if (
								jQuery(this).prop('disabled') ||
								jQuery(this).hasClass('disabled')
							) {
								e.preventDefault();
								e.stopImmediatePropagation();
								return false;
							}
						}
					);
				}

				if (cartComponent) {
					cartComponent.addToViewEventsDefinition('Cart.Summary.View', 'click [data-action="proceed"]', function (e) {
						var lines = []
							, enableProceedToCheckout = true;

						cartComponent.getLines().done(function (_lines) {
							lines = _lines;
							enableProceedToCheckout = _.every(lines || [], function (line) {
								console.log("LINE@@@@", line)
								var showCutLinkOption = line.item.extras.custitem_show_cut_link_on_pdp_page
									, showCutLinkOptionCart = line.item.extras.custitem_show_cut_link_on_cart_page
									, optionCutLink = _.find(line.options || [], { 'cartOptionId': 'custcol_web_cut_link' });

								return showCutLinkOption || showCutLinkOptionCart ? optionCutLink && !_.isEmpty(optionCutLink.value) : true;
							});
						});

						if (!enableProceedToCheckout) {
							e.stopPropagation();
							e.preventDefault();
							var view = new CustomMatrixOptionView({
								application: container
								, lines: lines
								, cartComponent: cartComponent
							});
							view.showInModal();
						}
						else {
							return e;
						}
					});


					_.extend(CartLinesView.prototype, {
						getContext: _.wrap(CartLinesView.prototype.getContext, function (fn) {
							var res = fn.apply(this, _.toArray(arguments).slice(1));
							console.log("CARTLINES VIEW GETCONTEXT", res);
							console.log("CARTLINES VIEW line options", res.line.attributes.options.models);
							var cutlengthObj = _.find(res.line.attributes.options.models, function (op) {
								console.log("op", op);
								return op.attributes.cartOptionId == "custcol_web_cut_link";
							})
							res.cutlengthVal = cutlengthObj && cutlengthObj.attributes.value.internalid;
							console.log("cutlengthVal", res.cutlengthVal)
							return res;
						})
					})

					cartComponent.addToViewEventsDefinition('Cart.Lines.View', 'change [data-action="cut-length"]', function (e) {
						console.log("e", e);
						console.log("e", e.target.dataset.lineid);
						var lineid = e.target.dataset.lineid;
						var itemoptionObj = {
							"cartOptionId": "custcol_web_cut_link",
							"label": "Cut Link",
							"values": [],
							"type": "text",
							"itemOptionId": "",
							"isMatrixDimension": false,
							"isMandatory": false,
							"urlParameterName": "custcol_web_cut_link",
							"useLabelsOnUrl": false,
							"index": 10
						}
						itemoptionObj.value = { "label": e.currentTarget.value, "internalid": e.currentTarget.value };
						cartComponent.getLines().then(function (lines) {
							console.log("lines", lines);
							var _line = _.find(lines, { internalid: lineid });
							_line.options.push(itemoptionObj);
							cartComponent.addLine({ line: _line });
							cartComponent.removeLine({ line_id: lineid });
							return line;
						});
					})

				}
			}
		};
	});
